import {
  DataLogsViewColumns,
  dataLogsSearchSchema,
  mapDataLogsViewQuery,
} from "./DataLogsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getDataLogs } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";

export interface DataLogsViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function DataLogsView(props: DataLogsViewProps) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={DataLogsViewColumns}
      schema={dataLogsSearchSchema}
      mapQuery={mapDataLogsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getDataLogs, { retry: true })}
      pageSize={100}
    />
  );
}

export default DataLogsView;
